if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        var pId = this.form.querySelector('[name="product-id"]').value;
        var cartId = this.cart.querySelector('cart-drawer-items').getAttribute('onceProduct');

        // console.log(typeof pId);
        // console.log(typeof cartId);
        // console.log(cartId);

        if (pId == '14962855117126' && cartId == 'true' ) {
          document.querySelector('[popup_show]').classList.add('open');
          document.body.classList.add('popup_open');
          return;
        };

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        let responseData; 
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            responseData = response; 
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);              
            } else {
              this.cart.renderContents(response);                            
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            
            const montageCheckbox = document.querySelector('input[data-montage-custom-check]:checked');        
            if(montageCheckbox){
              const formData = new FormData(this.form);
              const dataObject = Object.fromEntries(formData);  
              let props = {};    

              Object.entries(dataObject).forEach(([key, value]) => {    
                if (key.includes("properties[_current_time]") && value ) {
                  const propKey = key.match(/properties\[(.*?)\]/)[1];
                  props[propKey] = value;   
                  // console.log("props[propKey]",props[propKey]);               
                }
              })
              let mProduct = [{ id: montageCheckbox.getAttribute("product_id_attr"), quantity:dataObject.quantity || 1, properties: props}];              
               const ADDTOCART_OBJECT_MONTAGE = { items: mProduct };
                     custom_addtocart_fun(ADDTOCART_OBJECT_MONTAGE,true);
            }
            
            
            const checkedBoxes = document.querySelectorAll('input[name=bpcheckbox]:checked');
            if(checkedBoxes.length > 0){
               let products = [];
                   checkedBoxes.forEach(function (bdpcheckbox) {
                          if (bdpcheckbox.getAttribute("product_id")) {                            
                             products.push({ id: bdpcheckbox.getAttribute("product_id"), quantity:1}); 
                          }
                        });
                     const ADDTOCART_OBJECT_GIFT = { items: products };
                     custom_addtocart_fun(ADDTOCART_OBJECT_GIFT,true);
            }
                                              
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            // syncGiftWithMain(responseData);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
